// components/session-display.tsx

import { Session } from "@/lib/api";

interface SessionDisplayProps {
  session: Session | null;
  className?: string;
}

export function SessionDisplay({ session, className = '' }: SessionDisplayProps) {
  if (!session) {
    return (
      <div className={`bg-yellow-100 border border-yellow-400 rounded-lg p-3 ${className}`}>
        <p className="text-yellow-800 font-medium">No active session</p>
      </div>
    );
  }

  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-3 ${className}`}>
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-blue-900">Active Session</h3>
          <p className="text-blue-700">
            {session.name} • {session.drawTime}
          </p>
        </div>
        <div className="text-right">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Active
          </span>
          <p className="text-xs text-blue-600 mt-1">
            Created: {new Date(session.date).toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
}